import React from 'react';

export const pricing_matrix = [
  {
      columns: {
        'info': '',
        'basic': 'Basic',
        'pro': 'Pro',
        'team': 'Team',
        'enterprise': 'Enterprise'
      },
      matrix: {
        'Monthly Cost': {
          'basic': '$0',
          'pro': <span style={{ fontSize: "smaller" }}><p>$10/mo for Businesses</p><p>$7/mo for Non-Profits</p></span>,
          'team': <span style={{ fontSize: "smaller" }}><p>$100/mo for Businesses</p><p>$70/mo for Non-Profits</p></span>,
          'enterprise': 'Contact Us'
        },
        /*
        'Billed Annually': {
          'basic': '$0',
          'pro': <span style={{ fontSize: "smaller" }}><p>$8/mo for Businesses</p><p>$5/mo for Non-Profits</p></span>,
          'team': <span style={{ fontSize: "smaller" }}><p>$80/mo for Businesses</p><p>$50/mo Non-Profits</p></span>,
          'enterprise': 'Contact Us'
        },
        */
        '# of Users in plan': {
          'basic': '1',
          'pro': '1',
          'team': 'Up to 50',
          'enterprise': 'More than 50'
        },
        '# of presentations that you can create': {
          'basic': 'unlimited',
          'pro': 'unlimited',
          'team': 'unlimited',
          'enterprise': 'unlimited'
        },
        'Social Sharing': {
          'basic': '5 GB',
          'pro': '10 GB',
          'team': '25 GB',
          'enterprise': 'Varies'
        }
      }
  },
  {
    columns: {  
      'info': 'Public Features',
      'basic': 'Basic',
      'pro': 'Pro',
      'team': 'Team',
      'enterprise': 'Enterprise'
    },
    matrix: {
      'Upload Images': {
        basic: true,
        pro: true,
        team: true,
        enterprise: true
      },
      'Record or Upload Audio': {
        basic: true,
        pro: true,
        team: true,
        enterprise: true
      },
      'Transcription': {
        basic: true,
        pro: true,
        team: true,
        enterprise: true
      },
      'Publish to PechaKucha.com': {
        basic: true,
        pro: true,
        team: true,
        enterprise: true
      },
      'Social Sharing': {
        basic: true,
        pro: true,
        team: true,
        enterprise: true
      },
      'Embedding': {
        basic: true,
        pro: true,
        team: true,
        enterprise: true
      },
      'Track # of Views': {
        basic: true,
        pro: true,
        team: true,
        enterprise: true
      },
      'Flexible presentation formats (10x10,5x5,etc.)': {
        basic: true,
        pro: true,
        team: true,
        enterprise: true
      },
    }
  },
  {
    columns: {
      'info': 'Private Access',
      'basic': 'Basic',
      'pro': 'Pro',
      'team': 'Team',
      'enterprise': 'Enterprise'
    },
    matrix: {
      'Download Video File': {
        basic: false,
        pro: true,
        team: true,
        enterprise: true
      },
      'Download Presentation File': {
        basic: false,
        pro: true,
        team: true,
        enterprise: true
      },
      /*
      'Get Paid Through PechaKucha Tips (US Only)': {
        basic: false,
        pro: true,
        team: true,
        enterprise: true
      },
      */
      'Record/Upload Presenter Video for Video-in-Video': {
        basic: false,
        pro: true,
        team: true,
        enterprise: true
      },
      'Upload PowerPoint (.pptx) Files to Create Slides and Presentations': {
        basic: false,
        pro: true,
        team: true,
        enterprise: true
      },
      'Publish Content anywhere without PK branding': {
        basic: false,
        pro: true,
        team: true,
        enterprise: true
      },
      'Standard Customer Support': {
        basic: false,
        pro: true,
        team: true,
        enterprise: true
      }
    }
  },
  {
    columns: {
      'info': 'Collaboration Features',
      'basic': 'Basic',
      'pro': 'Pro',
      'team': 'Team',
      'enterprise': 'Enterprise'  
    },
    matrix: {
      'Dedicated Workspace': {
        basic: false,
        pro: false,
        team: true,
        enterprise: true
      },
      'Unique branding/curation': {
        basic: false,
        pro: false,
        team: true,
        enterprise: true
      },
      'User management': {
        basic: false,
        pro: false,
        team: true,
        enterprise: true
      },
      'Content Management': {
        basic: false,
        pro: false,
        team: true,
        enterprise: true
      },
      'Community PechaKucha Presentation': {
        basic: false,
        pro: false,
        team: true,
        enterprise: true
      },
      'Create Private Events': {
        basic: false,
        pro: false,
        team: true,
        enterprise: true
      },
      'Training Documentation': {
        basic: false,
        pro: false,
        team: true,
        enterprise: true
      },
      'Insight/analytics': {
        basic: false,
        pro: false,
        team: false,
        enterprise: true
      },
      'API Access': {
        basic: false,
        pro: false,
        team: false,
        enterprise: true
      },
      'Create public events (Powered by PK license)': {
        basic: false,
        pro: false,
        team: false,
        enterprise: true
      },
      'Conference/event management': {
        basic: false,
        pro: false,
        team: false,
        enterprise: true
      },
      'Central Billing': {
        basic: false,
        pro: false,
        team: false,
        enterprise: true
      },
      'Priority Customer Support': {
        basic: false,
        pro: false,
        team: false,
        enterprise: true
      }
    }
  }
];